import "core-js/modules/es.array.every";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.reduce";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.object.values";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.includes";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getStationOilDiscountCounter } from '@/api/bairun/financialCenter';
import NP from 'number-precision';
import { mapGetters } from 'vuex';
import dateUtils from '@/utils/dateUtil';
export default {
  name: 'SlotCounterStationDiscountPromotion',
  props: {
    start: {
      type: Number,
      required: true
    },
    end: {
      type: Number,
      required: true
    },
    totalId: {
      type: Number,
      default: 999
    },
    refIndex: {
      type: Number,
      required: true
    },
    sheetType: {
      type: String,
      required: true
    },
    slotCounterName: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      loading: false,
      slotOption: '',
      selectedOilCode: '92',
      selectedArea: '全部',
      dayNums: 0,
      monthNums: 0,
      daySumSvcNums: 0,
      daySumUserNums: 0,
      daySumPlatformNums: 0,
      monthSumSvcNums: 0,
      monthSumUserNums: 0,
      monthSumPlatformNums: 0,
      stationDailyDiscountData: [],
      tempGroupData: {},
      borderFix: ['合计/L', '合/L', '92#均价', '95#均价', '0#均价'],
      cellColClassFix: ['dayDiffDiscountPrice', 'monthDiffDiscountPrice'],
      filterMapping: [{
        text: '佛山',
        value: '佛山'
      }, {
        text: '粤西',
        value: '粤西'
      }, {
        text: '外省',
        value: '外省'
      }],
      showStations: [],
      customColors: [{
        color: '#909399',
        percentage: 30
      }, {
        color: '#f56c6c',
        percentage: 60
      }, {
        color: '#e6a23c',
        percentage: 85
      }, {
        color: '#409eff',
        percentage: 99
      }, {
        color: '#67c23a',
        percentage: 100
      }],
      excelSheets: [{
        tableId: 'stationDailyDiscountData',
        name: '油品优惠价差报表',
        tableRows: 2
      }]
    };
  },
  watch: {
    end: function end() {
      this.loadData();
    },
    refIndex: function refIndex() {
      this.refIndexRefresh();
    }
  },
  computed: _objectSpread({}, mapGetters('stations', ['asyncStations'])),
  created: function created() {
    this.loadData();
  },
  updated: function updated() {
    var _this = this;

    this.$nextTick(function () {
      _this.$refs['stationDailyDiscountData'].doLayout();
    });
  },
  methods: {
    cellStyle: function cellStyle(_ref) {
      var row = _ref.row,
          column = _ref.column;

      if (this.borderFix.includes(column.label)) {
        return 'border-right:1px solid #000000';
      }

      if (this.cellColClassFix.includes(column.property)) {
        return 'background: #ffe9cf';
      }
    },
    filterChange: function filterChange(selected) {
      this.selectedArea = selected['area'] && selected['area'][0] ? selected['area'][0] : '全部';
    },
    filterHandler: function filterHandler(value, row, column) {
      for (var i in this.asyncStations) {
        if (this.asyncStations[i]['ID'] === row['sellerId'] && this.asyncStations[i]['statArea'] === value) {
          return true;
        }
      }

      return false;
    },
    refIndexRefresh: function refIndexRefresh() {
      this.$refs['stationDailyDiscountData'].doLayout();
    },
    getSummaries: function getSummaries(param) {
      var columns = param.columns,
          data = param.data;
      var sums = [];
      var sums2 = [];
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = '合计';
          sums2[index] = '合计';
          return;
        }

        var values;
        var values2;

        if (column.property === 'dayDiffDiscountPrice92') {
          values = data.map(function (item) {
            return NP.times(item['daySumDiscount92'], 1);
          });
          values2 = data.map(function (item) {
            return NP.times(item['dayNums92'], 1);
          });
        } else if (column.property === 'dayDiffDiscountPrice95') {
          values = data.map(function (item) {
            return NP.times(item['daySumDiscount95'], 1);
          });
          values2 = data.map(function (item) {
            return NP.times(item['dayNums95'], 1);
          });
        } else if (column.property === 'dayDiffDiscountPrice0') {
          values = data.map(function (item) {
            return NP.times(item['daySumDiscount0'], 1);
          });
          values2 = data.map(function (item) {
            return NP.times(item['dayNums0'], 1);
          });
        } else if (column.property === 'monthDiffDiscountPrice92') {
          values = data.map(function (item) {
            return NP.times(item['monthSumDiscount92'], 1);
          });
          values2 = data.map(function (item) {
            return NP.times(item['monthNums92'], 1);
          });
        } else if (column.property === 'monthDiffDiscountPrice95') {
          values = data.map(function (item) {
            return NP.times(item['monthSumDiscount95'], 1);
          });
          values2 = data.map(function (item) {
            return NP.times(item['monthNums95'], 1);
          });
        } else if (column.property === 'monthDiffDiscountPrice0') {
          values = data.map(function (item) {
            return NP.times(item['monthSumDiscount0'], 1);
          });
          values2 = data.map(function (item) {
            return NP.times(item['monthNums0'], 1);
          });
        } else {
          values = data.map(function (item) {
            return Number(item[column.property]);
          });
          values2 = data.map(function (item) {
            return Number(item[column.property]);
          });
        }

        if (!values.every(function (value) {
          return isNaN(value);
        })) {
          sums[index] = values.reduce(function (prev, curr) {
            var value = Number(curr);

            if (!isNaN(value)) {
              return NP.plus(prev, curr);
            } else {
              return prev;
            }
          }, 0);
          sums[index] = NP.round(sums[index], 2);
        } else {
          sums[index] = 'N/A';
        }

        if (!values2.every(function (value) {
          return isNaN(value);
        })) {
          sums2[index] = values2.reduce(function (prev, curr) {
            var value = Number(curr);

            if (!isNaN(value)) {
              return NP.plus(prev, curr);
            } else {
              return prev;
            }
          }, 0);
          sums2[index] = NP.round(sums2[index], 2);
        } else {
          sums2[index] = 'N/A';
        }
      });
      sums[3] = sums[1] > 0 ? NP.round(NP.divide(sums[2], sums[1]), 2) : '-';
      sums[4] = sums2[4] > 0 ? NP.round(NP.divide(sums[4], sums2[4]), 2) : '-';
      sums[5] = sums2[5] > 0 ? NP.round(NP.divide(sums[5], sums2[5]), 2) : '-';
      sums[6] = sums2[6] > 0 ? NP.round(NP.divide(sums[6], sums2[6]), 2) : '-';
      sums[9] = sums[7] > 0 ? NP.round(NP.divide(sums[8], sums[7]), 2) : '-';
      sums[10] = sums2[10] > 0 ? NP.round(NP.divide(sums[10], sums2[10]), 2) : '-';
      sums[11] = sums2[11] > 0 ? NP.round(NP.divide(sums[11], sums2[11]), 2) : '-';
      sums[12] = sums2[12] > 0 ? NP.round(NP.divide(sums[12], sums2[12]), 2) : '-';
      return sums;
    },
    sellerName: function sellerName(sellerId) {
      for (var i in this.asyncStations) {
        if (this.asyncStations[i].ID === sellerId) {
          return this.asyncStations[i]['statAbbr'];
        }
      }

      return '';
    },
    loadData: function loadData() {
      var _this2 = this;

      if (this.loading) {
        return;
      }

      this.loading = true;
      var descriptorData = {
        descriptors: [{
          type: 'ocosotpc',
          operator: 'dateOCOSOTPC',
          t: null,
          name: this.slotCounterName,
          start: this.end / 1000 - 24 * 60 * 60,
          end: this.end / 1000,
          search: this.totalId === 999 ? '' : this.totalId.toString()
        }]
      };
      getStationOilDiscountCounter(descriptorData).then(function (response) {
        var tmpGroupData = Object.values(response.data).sort(function (a, b) {
          var orders = [10006, 10003, 10011, 10013, 10010, 10014, 10001, 10012, 10002, 10005, 10004, 10009, 10008, 10015]; // // console.log('sort orders', orders.indexOf(a.sellerId), orders.indexOf(b.sellerId))

          return orders.indexOf(a.sellerId) - orders.indexOf(b.sellerId);
        });

        var retObj = _this2.groupDataFilter(tmpGroupData); // console.log('retObj', retObj)


        _this2.stationDailyDiscountData = Object.values(retObj).sort(function (a, b) {
          var orders = [10006, 10003, 10011, 10013, 10010, 10014, 10001, 10012, 10002, 10005, 10004, 10009, 10008, 10015]; // console.log('sort orders', orders.indexOf(a.sellerId), orders.indexOf(b.sellerId))

          return orders.indexOf(a.sellerId) - orders.indexOf(b.sellerId);
        }); // console.log('this.stationDailyDiscountData', this.stationDailyDiscountData)

        _this2.loading = false;
        _this2.sheetUnLoadCount = 0;

        _this2.$refs['stationDailyDiscountData'].doLayout();
      }).catch(function () {
        _this2.loading = false;
      });
    },
    groupDataFilter: function groupDataFilter(data) {
      var obj = {};
      data.forEach(function (el) {
        var tmpObj = {
          'sellerId': 0,
          'dayNums': 0,
          'daySumDiscount': 0,
          'dayDiffDiscountPrice': 0,
          'dayNums92': 0,
          'daySumDiscount92': 0,
          'dayDiffDiscountPrice92': 0,
          'dayNums95': 0,
          'daySumDiscount95': 0,
          'dayDiffDiscountPrice95': 0,
          'dayNums0': 0,
          'daySumDiscount0': 0,
          'dayDiffDiscountPrice0': 0,
          'monthNums': 0,
          'monthSumDiscount': 0,
          'monthDiffDiscountPrice': 0,
          'monthNums92': 0,
          'monthSumDiscount92': 0,
          'monthDiffDiscountPrice92': 0,
          'monthNums95': 0,
          'monthSumDiscount95': 0,
          'monthDiffDiscountPrice95': 0,
          'monthNums0': 0,
          'monthSumDiscount0': 0,
          'monthDiffDiscountPrice0': 0
        };

        if (!obj[el.sellerId]) {
          var dayExtraDiscount = NP.round(NP.times(el.dayNums, NP.minus(el.dayGoodsOriginal, el.dayGoodsPrice)), 2);
          var monthExtraDiscount = NP.round(NP.times(el.monthNums, NP.minus(el.monthGoodsOriginal, el.monthGoodsPrice)), 2);
          tmpObj['sellerId'] = el.sellerId;
          tmpObj['dayNums'] = el.dayNums;
          tmpObj['monthNums'] = el.monthNums;
          tmpObj['daySumDiscount'] = NP.round(NP.plus(el.daySumUserDiscount, el.daySumSvcDiscount, el.daySumPlatformDiscount, dayExtraDiscount), 2);
          tmpObj['monthSumDiscount'] = NP.round(NP.plus(el.monthSumUserDiscount, el.monthSumSvcDiscount, el.monthSumPlatformDiscount, monthExtraDiscount), 2);
          tmpObj['dayDiffDiscountPrice'] = tmpObj['dayNums'] === 0 ? 0 : NP.round(NP.divide(tmpObj['daySumDiscount'], tmpObj['dayNums']), 2);
          tmpObj['monthDiffDiscountPrice'] = tmpObj['monthNums'] === 0 ? 0 : NP.round(NP.divide(tmpObj['monthSumDiscount'], tmpObj['monthNums']), 2);
          tmpObj['dayNums' + el.oilCode] = el.dayNums;
          tmpObj['daySumDiscount' + el.oilCode] = NP.round(NP.plus(el.daySumUserDiscount, el.daySumSvcDiscount, el.daySumPlatformDiscount, dayExtraDiscount), 2);
          tmpObj['dayDiffDiscountPrice' + el.oilCode] = el.dayNums === 0 ? 0 : NP.round(NP.divide(NP.plus(el.daySumUserDiscount, el.daySumSvcDiscount, el.daySumPlatformDiscount, dayExtraDiscount), el.dayNums), 2);
          tmpObj['monthNums' + el.oilCode] = el.monthNums;
          tmpObj['monthSumDiscount' + el.oilCode] = NP.round(NP.plus(el.monthSumUserDiscount, el.monthSumSvcDiscount, el.monthSumPlatformDiscount, monthExtraDiscount), 2);
          tmpObj['monthDiffDiscountPrice' + el.oilCode] = el.monthNums === 0 ? 0 : NP.round(NP.divide(NP.plus(el.monthSumUserDiscount, el.monthSumSvcDiscount, el.monthSumPlatformDiscount, monthExtraDiscount), el.monthNums), 2);
          obj[el.sellerId] = tmpObj;
        } else {
          var _dayExtraDiscount = NP.round(NP.times(el.dayNums, NP.minus(el.dayGoodsOriginal, el.dayGoodsPrice)), 2);

          var _monthExtraDiscount = NP.round(NP.times(el.monthNums, NP.minus(el.monthGoodsOriginal, el.monthGoodsPrice)), 2);

          obj[el.sellerId]['sellerId'] = el.sellerId;
          obj[el.sellerId]['dayNums'] = NP.round(NP.plus(obj[el.sellerId]['dayNums'], el.dayNums), 2);
          obj[el.sellerId]['monthNums'] = NP.round(NP.plus(obj[el.sellerId]['monthNums'], el.monthNums), 2);
          obj[el.sellerId]['daySumDiscount'] = NP.round(NP.plus(obj[el.sellerId]['daySumDiscount'], el.daySumUserDiscount, el.daySumSvcDiscount, el.daySumPlatformDiscount, _dayExtraDiscount), 2);
          obj[el.sellerId]['monthSumDiscount'] = NP.round(NP.plus(obj[el.sellerId]['monthSumDiscount'], el.monthSumUserDiscount, el.monthSumSvcDiscount, el.monthSumPlatformDiscount, _monthExtraDiscount), 2);
          obj[el.sellerId]['dayDiffDiscountPrice'] = obj[el.sellerId]['dayNums'] === 0 ? 0 : NP.round(NP.divide(obj[el.sellerId]['daySumDiscount'], obj[el.sellerId]['dayNums']), 2);
          obj[el.sellerId]['monthDiffDiscountPrice'] = obj[el.sellerId]['monthNums'] === 0 ? 0 : NP.round(NP.divide(obj[el.sellerId]['monthSumDiscount'], obj[el.sellerId]['monthNums']), 2);
          obj[el.sellerId]['dayNums' + el.oilCode] = el.dayNums;
          obj[el.sellerId]['daySumDiscount' + el.oilCode] = NP.round(NP.plus(el.daySumUserDiscount, el.daySumSvcDiscount, el.daySumPlatformDiscount, _dayExtraDiscount), 2);
          obj[el.sellerId]['dayDiffDiscountPrice' + el.oilCode] = el.dayNums === 0 ? 0 : NP.round(NP.divide(NP.plus(el.daySumUserDiscount, el.daySumSvcDiscount, el.daySumPlatformDiscount, _dayExtraDiscount), el.dayNums), 2);
          obj[el.sellerId]['monthNums' + el.oilCode] = el.monthNums;
          obj[el.sellerId]['monthSumDiscount' + el.oilCode] = NP.round(NP.plus(el.monthSumUserDiscount, el.monthSumSvcDiscount, el.monthSumPlatformDiscount, _monthExtraDiscount), 2);
          obj[el.sellerId]['monthDiffDiscountPrice' + el.oilCode] = el.monthNums === 0 ? 0 : NP.round(NP.divide(NP.plus(el.monthSumUserDiscount, el.monthSumSvcDiscount, el.monthSumPlatformDiscount, _monthExtraDiscount), el.monthNums), 2);
        }
      });
      return obj;
    },
    timestamp2datestring: function timestamp2datestring(ts) {
      var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      return dateUtils.timeStampToString(ts, format);
    }
  }
};